export default () => ({
  count: 0,
  countApplicationsInomplete: 0,
  applicationsLoaded: false,
  personalityNotification: false,
  suggestedNotifications: 0,
  redeemTransactions: [],
  userRedeem: 0
})
